export function FallbackView() {
  return (
    <div className="splash-screen">
      <img src="/media/logos/IsoMilkomeda.svg" alt="Logo Milkomeda" />
      <span>Loading ...</span>
    </div>
  );
}
